import { Box, ToggleButton, Typography } from '@mui/material';
import React from 'react';
import MapLayerChooserButton from '../MapLayerChooserButton/MapLayerChooserButton';
import { ModuleConfig } from '@schamburg-web/interfaces';
import { useModules } from '@schamburg-web/components';

const LayerChooser: React.FC = () => {
  const { modules } = useModules();
  const mapModules = modules.filter((module) => module.mapConfig.showOnMap);

  return (
    <Box className={'map-control-container'} sx={{ padding: '10px' }}>
      {mapModules.map((module: ModuleConfig) => (
        <LayerChooserButton module={module} key={module.name} />
      ))}
    </Box>
  );
};

const LayerChooserButton: React.FC<{ module: ModuleConfig }> = ({ module }) => {
  const { modulesEnabled, setModulesEnabled } = useModules();

  return (
    <ToggleButton
      sx={{
        '&.MuiToggleButton-root': {
          backgroundColor: 'transparent',
          color: 'black',
          border: 'none',
          padding: 0,
        },
        '&.Mui-selected': {
          backgroundColor: 'transparent',
        },
        '&.Mui-selected:hover': {
          backgroundColor: 'transparent',
        },
        justifyContent: 'flex-start',
        width: '100%',
        textTransform: 'none',
      }}
      value={module.name}
      onChange={() =>
        setModulesEnabled(module.name, !modulesEnabled[module.name])
      }
      selected={modulesEnabled[module.name]}
      disableRipple
    >
      <LayerChooserButtonLabel module={module} />
    </ToggleButton>
  );
};

const LayerChooserButtonLabel: React.FC<{ module: ModuleConfig }> = ({
  module,
}) => {
  //const myMapLayerRow = module.displayConfig.mapLayerRow || null;
  return <MapLayerChooserButton module={module} />;
  //return <div></div>;
};
export default LayerChooser;
